export const CONFIRM_DIALOG_COPY = {
  cancel: "Cancel",
} as const;

export const ACCESS_GRANT_COPY = {
  verifyWithoutDocsTitle: "Verify without documents?",
  verifyWithoutDocsBody:
    "This marks the company verified without reviewing a KYC pack. Marketplace access follows the usual rules after this.",
  verifyWithoutDocsCta: "Verify without docs",
  rejectCompanyTitle: "Reject this company?",
  rejectCompanyBody:
    "The company stays unverified. They must update documents and resubmit before marketplace access.",
  rejectCta: "Reject",
  rejectCompanyCta: "Reject company",
  rejectHrKycTitle: "Reject HR KYC?",
  rejectHrKycBody: "They cannot publish until they update identity details and resubmit.",
  rejectHrKycCta: "Reject KYC",
  rejectRecruiterTitle: "Reject this recruiter?",
  rejectRecruiterBody: "They stay unverified. They must update documents and resubmit.",
  rejectAffiliateTitle: "Reject this affiliate?",
  rejectAffiliateBody: "They stay unverified. They must update documents and resubmit.",
  rejectKycCta: "Reject",
  reasonLabel: "Reason",
  rejectRecruiterReasonHint: "The recruiter sees this and can replace failed files.",
} as const;
